export default __webpack_public_path__ + "static/media/dcheck.4841de84.svg";